import { kea } from 'kea'

import heartLogic from '../favorite-button/logic'

export default kea({
  connect: {
    actions: [heartLogic, ['toggleWishlistStatus']],
    props: [heartLogic, ['isInWishlist', 'isToggling']]
  }
})
